import {Box, Card, Modal, type ModalProps} from '@mantine/core'
import type {MergedRecommendation} from '@package/shared'
import {useDayItems} from '../../../providers/dayItems/useDayItems.ts'
import {useMemo} from 'react'
import {TimeEntryContainer} from '../TimeEntryContainer.tsx'
import dayjs from 'dayjs'

type Props = {
  mergedRecommendation: MergedRecommendation
} & Pick<ModalProps, 'opened' | 'onClose'>

export const MergedRecommendationsModal = ({mergedRecommendation, opened, onClose}: Props) => {
  const {dayItems} = useDayItems()

  const recommendations = useMemo(() => {
    const recommendationIds = mergedRecommendation.recommendations.map(({id}) => id)
    return dayItems
      .filter((dayItem) => dayItem.type === 'recommendation')
      .map((dayItem) => dayItem.item)
      .filter((recommendation) => recommendationIds.includes(recommendation.id))
  }, [dayItems, mergedRecommendation.recommendations])

  return (
    <Modal opened={opened} onClose={onClose} title={'Merged recommendations'}>
      <Box pt={'md'} style={{display: 'flex', flexDirection: 'column', gap: 5}}>
        {recommendations.map((recommendation) => (
          <Card key={recommendation.id} p={'xs'}>
            <TimeEntryContainer
              start={dayjs(recommendation.start)}
              end={dayjs(recommendation.end)}
              description={recommendation.description}
              breakHours={recommendation?.breakHours}
              sourceType={recommendation.source?.type}
              projectId={recommendation.projectId}
              merged={false}
              disableCompactMode
            />
          </Card>
        ))}
      </Box>
    </Modal>
  )
}
